import { render, staticRenderFns } from "./guns.vue?vue&type=template&id=4115027d&"
import script from "./guns.vue?vue&type=script&lang=js&"
export * from "./guns.vue?vue&type=script&lang=js&"
import style0 from "./guns.vue?vue&type=style&index=0&id=4115027d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports